import { DecoratedHttpClient, TokenHandlingHttpClient } from "@ftdr/http-utils";

export class CustomTenantHttpClient extends DecoratedHttpClient {
  defaults: DecoratedHttpClient["defaults"] = {
    headers: {
      common: {
        ["X-Tenant"]: this.tenant,
      },
    },
  };

  constructor(
    token: string,
    private tenant: string,
    tokenRefresher?: () => Promise<string>
  ) {
    super(new TokenHandlingHttpClient(token, tokenRefresher));
    this.mergeDefaults();
  }
}
